import React, { useState, useEffect } from "react";
import _, { isArray } from "lodash";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Row, Col } from "react-bootstrap";
import ApiAmusementService from "../../../core/api/api.amusementService";
import "../../pages/_Components/ReactBeautifulDnd.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import SwalMessage from "../_Components/SwalMessage";
import ApiAmusementServiceReserveItemGroup from "../../../core/api/api.amusementServiceReserveItemGroup";
import SelectComponent from "../_Components/ReactSelectComponent";

const ChangeOrderReserveItemGroup = ({ showModalReserveItemGroupOrder, setShowModalReserveItemGroupOrder }) => {
  const [reserveItemGroups, setReserveItemGroups] = useState([]);
  const [services, setServices] = useState([]);
  const [formInputs, setFormInputs] = useState({});
  // Fetch all services
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const data = await ApiAmusementService.getAllServices();
        if (!_.isEmpty(data)) {
          setServices(data);
        }
      } catch (error) {
      }
    };

    fetchServices();
  }, []);
  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const updatedReserveItemGroups = Array.from(reserveItemGroups);
    const [reorderedItem] = updatedReserveItemGroups.splice(result.source.index, 1);
    updatedReserveItemGroups.splice(result.destination.index, 0, reorderedItem);
    setReserveItemGroups(updatedReserveItemGroups);
  };
  const handleClose = () => {
    setShowModalReserveItemGroupOrder(false);
  };
  const sendSortedReserveItemGroups = async () => {
    try {
      // اطلاعات مورد نیاز برای ارسال به سرور
      const dataToSend = {
        reserveItemGroups: reserveItemGroups.map((item) => ({ id: item.id, title: item.title })),
      };
      // ارسال درخواست به سرور
      const response =
        await ApiAmusementServiceReserveItemGroup.changeOrderAmusementServiceReserveItemGroup(dataToSend);
      SwalMessage({ title: response.message, iSsuccess: true });
      setShowModalReserveItemGroupOrder(false);
    } catch (error) {
    }
  };
  ///
  const handleServiceChange = (selectedOption) => {
    inputChangeHandler2(selectedOption);
  };
  const inputChangeHandler2 = async (selectedOption) => {
    if (selectedOption && !isArray(selectedOption)) {
      const { type, value } = selectedOption;

      setFormInputs((prevState) => ({
        ...prevState,
        [type]: selectedOption,
      }));

      try {
        const itemGroupResponse = await ApiAmusementServiceReserveItemGroup.getAllReserveItemGroups(value);
        if (itemGroupResponse) {
          const activeItemGroupResponse = itemGroupResponse.filter(a => a.isActive);
          setReserveItemGroups(activeItemGroupResponse);
        }
      } catch (error) {
      }
    }
    else {
      setFormInputs(null)
      setReserveItemGroups([])
    }
  };
  return (
    <div>
      <div className="card-body pt-3 pb-0">
        {/* Start Modal */}
        <Modal centered size="md" show={showModalReserveItemGroupOrder} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>ترتیب قرارگیری گروه های آیتم در این سرویس</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs="12" style={{ zIndex: "3" }}>
                <SelectComponent
                  className="w-100 mt-2 mb-3"
                  placeholder="انتخاب تفریح"
                  options={services?.map((item) => ({
                    value: item.id,
                    label: item.name,
                    type: "service",
                  }))}
                  value={formInputs?.service || ""}
                  onChange={handleServiceChange}
                />
              </Col>
            </Row>
            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <ul className="sortable-list" {...provided.droppableProps} ref={provided.innerRef}>
                    {reserveItemGroups.map((item, index) => (
                      <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                        {(provided) => (
                          <li
                            className="sortable-item"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <span>{item.title}</span>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={sendSortedReserveItemGroups}>
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};
export default ChangeOrderReserveItemGroup;
